import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import type { CuratorVaultsFilters } from '../config/CuratorVaultsTable.config';
import type { CuratorVaultsTableRow } from '../config/CuratorVaultsTable.types';
interface UseApplyCuratorVaultsFiltersParams {
  items: readonly CuratorVaultsTableRow[];
  filters: CuratorVaultsFilters;
}
export const getCuratorAssetSelector = (asset: {
  chain: {
    id: number;
  };
  address: string;
}): string => `${asset.chain.id}:${asset.address.toLowerCase()}`;
export const matchesAssetFilter = (item: CuratorVaultsTableRow, assetsFilter: CuratorVaultsFilters['assets']) => assetsFilter.length === 0 || assetsFilter.some(selector => selector.toLowerCase() === getCuratorAssetSelector(item.vault.asset));
export const matchesChainFilter = (item: CuratorVaultsTableRow, chainsFilter: CuratorVaultsFilters['chains']) => !chainsFilter || chainsFilter.length === 0 || chainsFilter.includes(item.vault.chainId);
export const matchesSearchFilter = (item: CuratorVaultsTableRow, search: CuratorVaultsFilters['search']) => search.length === 0 || item.vault.name.toLowerCase().includes(search.toLowerCase()) || item.vault.address.toLowerCase().includes(search.toLowerCase()) || item.vault.asset.address.toLowerCase().includes(search.toLowerCase());
export const matchesVaultV2Filter = (item: CuratorVaultsTableRow, vaultV2Filter: CuratorVaultsFilters['v2']) => !vaultV2Filter || item.vault.version === '2.0';
export const useApplyCuratorVaultsFilters = t0 => {
  const $ = _c(13);
  const {
    items,
    filters
  } = t0;
  const {
    assets,
    chains,
    search,
    v2
  } = filters;
  let t1;
  if ($[0] !== assets || $[1] !== chains || $[2] !== items || $[3] !== search || $[4] !== v2) {
    let t2;
    if ($[6] !== assets || $[7] !== chains || $[8] !== search || $[9] !== v2) {
      t2 = item => matchesAssetFilter(item, assets) && matchesChainFilter(item, chains) && matchesSearchFilter(item, search) && matchesVaultV2Filter(item, v2);
      $[6] = assets;
      $[7] = chains;
      $[8] = search;
      $[9] = v2;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    t1 = items.filter(t2);
    $[0] = assets;
    $[1] = chains;
    $[2] = items;
    $[3] = search;
    $[4] = v2;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const filteredItems = t1;
  let t2;
  if ($[11] !== filteredItems) {
    t2 = {
      filteredItems,
      itemsCount: filteredItems.length
    };
    $[11] = filteredItems;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};